import Vue from "vue"
import App from "./App.vue"
import router from "./router"

import { t$ } from "@/assets/js/lct.js"
import axiosExt from "@/assets/js/axios.ext"
import "@/assets/js/helper"
import { modules } from "@/assets/js/helper"
// import Paginate from "vuejs-paginate";
import Antd, { message } from "ant-design-vue"
import "ant-design-vue/dist/antd.less"
import "@/assets/css/board-theme.less"
import "@/assets/css/main.css"
import "@/assets/css/sidebar.scss"
import "@/assets/css/style.css"
import "@/assets/css/new.css"

import langTabs from "@/components/utils/lang-tabs"
import blankContainer from "@/components/utils/blank-container"
import spinner from "@/components/utils/spinner"
import { i18n } from "@/assets/js/vue-i18n-init"
// import moment from "moment";
import store from "./store"

import PerfectScrollbar from "vue2-perfect-scrollbar"
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"

import { Cropper } from "vue-advanced-cropper"

import Vuelidate from "vuelidate"
Vue.use(Vuelidate)

Vue.use(Antd)

Vue.use(PerfectScrollbar)

// import VueMask from "v-mask";
// Vue.use(VueMask);

import { VueMaskDirective } from "v-mask"
Vue.directive("mask", VueMaskDirective)

Vue.component("lang-tabs", langTabs)
Vue.component("blank-container", blankContainer)
Vue.component("spinner", spinner)
Vue.component("cropper", Cropper)

// Vue.component("paginate", Paginate);

import moment from "moment-timezone"
moment.tz.setDefault("Asia/Tashkent")

moment.locale("ru")

Vue.prototype.moment = moment
Vue.prototype.$message = message
Vue.prototype.$api = axiosExt

// Vue.prototype.$fileUrl = process.env.VUE_APP_FILE_URL;

window.t$ = t$

store.$api = axiosExt

const token = sessionStorage.getItem("token")

if (token) {
  store.commit("setToken", token)
}

router.beforeEach((to, from, next) => {
  // let language = to.params.lang;
  // if (!language) {
  //   language = 'ru';
  // }

  // i18n.locale = language;
  // next();
  // store.dispatch('checkAuthorization')
  modules.linkDrag(to)

  if (store.getters.isLoggedIn) {
    if (to.path === "/login") {
      next("/")
    } else {
      const profileAccessLevel = store.state.user.profile.access_level
      const accessGroup = (to.meta || {}).access_group || []
      // console.log('accesLevel', profileAccessLevel);
      // console.log('to', to);
      // console.log('Can navigate or not? ', accessGroup.includes(profileAccessLevel));

      if (!accessGroup.includes(profileAccessLevel)) {
        // next()
        return
      }
      next()
    }
  } else {
    if (to.name !== "login") {
      next({
        name: "login",
        query: {
          redirect: to.fullPath
        }
      })
    }
  }

  next()
})

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    defaultPaginationProps() {
      return function (route) {
        return {
          page: route.query.page || 1,
          per_page: route.query.limit || 10
        }
      }
    }
  },

  methods: {
    copySlugToBuffer(textToCopy) {
      this.copyStringToClipboard(textToCopy)
      this.$message.success("ЧПУ скопирован")
    },

    hotGenerateSlug(
      $event,
      form,
      langPrefix,
      post = "post",
      postType = "news"
    ) {
      // if(form.id) {
      //   // if news has id no autotranslate
      //   return
      // }

      if (
        (Object.keys(form.title) || [])
          .filter((item) => item != langPrefix)
          .some((item) => form.title[item])
      ) {
        return
      }

      this.$__slugCompute({
        event: $event,
        langTab: langPrefix,
        type: post,
        title: form.title,
        postType: postType
      })
    },

    async runWithCallback(callbacksArr, postFunction) {
      Promise.all(callbacksArr).then(() => {
        if (typeof postFunction === "function") {
          postFunction.apply(Vue)
        }
        //  else {
        //   console.error("not function");
        // }
      })
    },

    delayedFunction(arg, ms = 2000) {
      return new Promise((resolve) => {
        const timer = setTimeout(() => {
          resolve(arg)
          clearTimeout(timer)
        }, ms)
      })
    },

    $_setRoutePage(pageNumber) {
      this.$router.push(
        {
          query: {
            ...this.$route.query,
            page: pageNumber
          }
        },
        () => {}
      )
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
  // renderError(h, err) {
  //   return h('pre', { style: { color: 'red' } }, err.stack)
  // }
}).$mount("#app")
